import React, {Component} from 'react';
import ReactLoading from 'react-loading';


class Loader extends React.Component {
  render() {
return <div class="row cnt-loader">
         <div class="col-lg-12">
             <div class="section-title middle ">
                 <h3>സേവനങ്ങൾ</h3><ReactLoading type="bubbles" color="green" height={50} width={35} />
            </div>
        </div>
    </div>


    }
}
export default Loader;